import { Alert, Form, Select, Tree } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { authenticateToken } from "../../../utils/auth";
import Loading from "../../common/Loader";
import { responseNotification } from "../../../utils/notify";
import HubLayout from "../Layout";
import _ from "lodash";
import HubHeader from "../Layout/topHeader";
import { debounce } from "lodash";
import { getParamValue } from "../../../utils";
import { useSelector } from "react-redux";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
const { Option } = Select;
const { DirectoryTree } = Tree;

const HubCategoryDetails = () => {
  const { hubInfo } = useSelector((state) => (state as any)?.authReducer);
  const [type, setType] = useState<string>("JC_MART");
  const [loading, setLoading] = useState(false);
  const [key, setKey] = useState("");
  const [visible, setVisible] = useState(undefined);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [singleCategoryInfo, setSingleCategoryInfo] = useState({
    loading: false,
    data: null,
  });
  const [categoryOptions, setCategoriesOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [categoryId, setCategoryId] = useState<any>();
  const [categoryName, setCategoryName] = useState<any>();
  const [categoryData, setCategoryData] = useState({
    loading: false,
    data: null,
  });

  const route = useParams();
  const [selectedCategory, setSelectedCategory] = useState(undefined);
  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [limit, setLimit] = useState(16);

  const fetchCategoryDetails = useCallback(() => {
    setSingleCategoryInfo({ loading: true, data: undefined });
    axios
      .get(
        `${
          process.env.REACT_APP_CATALOG_READER_API
        }/admin/category/detail?categoryId=${(route as any).categoryId}`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((data) => {
        if (data.status === 200) {
          setSingleCategoryInfo({
            loading: false,
            data: data?.data?.category,
          });
        } else {
          setSingleCategoryInfo({ loading: false, data: null });
          responseNotification(
            data.statusText || "something went wrong",
            "error"
          );
        }
      })
      .catch((err) => {
        setSingleCategoryInfo({ loading: false, data: null });

        console.log(err);
      });
  }, []);

  // All Category List For Add Category
  const getCategoriesOptions = useCallback(async () => {
    setCategoriesOptions({ loading: true, list: [] });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    const res = await axios.get(
      `${encodedUri}/admin/category/parent-by-type?page=${page || 0}&limit=${
        limit || 16
      }` +
        (type ? `&type=${type}` : ``) +
        (key ? `&key=${key}` : ``),
      {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      }
    );

    setCategoriesOptions({
      loading: false,
      list: res?.data?.categories?.map((category: { id: any; title: any }) => {
        return {
          value: category?.id,
          label: category?.title,
        };
      }),
    });
  }, [key]);

  const fetchRef = useRef(0);
  const categorySearchDebounce = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      getCategoriesOptions();
    };

    return debounce(loadOptions, 800);
  }, [getCategoriesOptions]);

  // Category List By Hub ID
  const getHubSubCategory = useCallback(() => {
    setCategoryData({ loading: true, data: undefined });
    axios
      .get(
        `${
          process.env.REACT_APP_CATALOG_READER_API
        }/admin/category/child-category-by-parent?categoryId=${
          (route as any).categoryId
        }`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((data) => {
        if (data.status === 200) {
          setCategoryData({
            loading: false,
            data: data?.data,
          });
        } else {
          setCategoryData({ loading: false, data: null });
          responseNotification(
            data.statusText || "something went wrong",
            "error"
          );
        }
      })
      .catch((err) => {
        setCategoryData({ loading: false, data: null });

        console.log(err);
      });
  }, []);

  useEffect(() => {
    getHubSubCategory();
    fetchCategoryDetails();
  }, [fetchCategoryDetails, getHubSubCategory]);

  const changeOrder = async (pos, node) => {
    let curr;
    let item;

    categoryData?.data?.categories?.find((category, i) => {
      if (category?.category?.id === node?.key) {
        curr = i;
        item = category;
      }
    });

    const formated =
      curr !== pos &&
      _.concat(
        curr < pos
          ? categoryData?.data?.categories
              ?.filter((_, i) => i !== curr)
              ?.slice(0, pos - 1)
          : categoryData?.data?.categories?.slice(0, pos),
        item,
        curr > pos
          ? categoryData?.data?.categories
              ?.filter((_, i) => i !== curr)
              ?.slice(pos, categoryData?.data?.categories?.length - 1)
          : categoryData?.data?.categories?.slice(
              pos,
              categoryData?.data?.categories?.length
            )
      )?.map((item, i) => ({
        categoryId: item?.category?.id,
        displayOrder: i + 1,
      }));

    if (formated) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/category-hub`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          categories: formated,
          hubId: hubInfo?.id,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            getHubSubCategory();
            responseNotification("Position Updated Successfully", "success");
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const categoryInfo = singleCategoryInfo?.data;

  return (
    <React.Fragment>
      <HubLayout hubId={hubInfo?.id as string}>
        <div className="product-list-item-area white-bg">
          <HubHeader leftarea={"Category Details"} rightarea={""} />

          <div className="details-area">
            <div className="details-area_">
              <div className="pt-4">
                <div className="inner-body">
                  <div className="single">
                    <span className="info-name">Category Name</span>
                    <span className="info-desc">{categoryInfo?.title}</span>
                  </div>

                  <div className="single">
                    <span className="info-name">Slug</span>
                    <span className="info-desc">{categoryInfo?.slug}</span>
                  </div>

                  <div className="single">
                    <span className="info-name">ID</span>
                    <span className="info-desc">{categoryInfo?.id}</span>
                  </div>

                  <div className="single">
                    <span className="info-name">Type</span>
                    <span className="info-desc">
                      {categoryInfo?.type?.replace("_", " ")}
                    </span>
                  </div>

                  <div className="single">
                    <span className="info-name">Status</span>
                    <div className="info-desc">
                      <span
                        className={`radius-btn text-uppercase ${
                          categoryInfo?.deleted === true ? "inacive" : "active"
                        }-btn`}
                      >
                        {categoryInfo?.deleted === true ? (
                          <>
                            <CloseOutlined className="mr-1" /> Inactive
                          </>
                        ) : (
                          <>
                            <CheckOutlined className="mr-1" /> Active{" "}
                          </>
                        )}
                        {categoryInfo?.status?.split("_").join(" ")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="pt-3">
              {categoryData?.loading ? (
                <Loading />
              ) : (
                <div className="product-table-area mt-3">
                  <h4 className="title">Sub-Categories</h4>
                  {/* {categoryData?.data?.lenght ? ( */}
                  <DirectoryTree
                    height={600}
                    showLine
                    multiple
                    showIcon={false}
                    // switcherIcon={<DownOutlined />}
                    treeData={categoryData?.data?.categories.map(
                      (category) => ({
                        title: category?.title,
                        key: category?.id,
                      })
                    )}
                    onDrop={(e) => {
                      changeOrder(e.dropPosition, e.dragNode);
                    }}
                    onRightClick={(val) => {
                      setCategoryId(val?.node?.key);
                      setCategoryName(val?.node?.title);
                      setVisible(val?.node?.key);
                      console.log(val);
                    }}
                  />
                  {/* ) : (
                    <Alert type="warning" message="No Data Found!" />
                  )} */}
                </div>
              )}
            </div>
          </div>
        </div>
      </HubLayout>
    </React.Fragment>
  );
};

export default HubCategoryDetails;
